import "./userGreeting.css";
import { UserGreetingProps } from "./userGreeting.props";
import { useLanguage } from "../../hooks";
import { PersonOutline } from "../../assets";

const UserGreeting: React.FC<UserGreetingProps> = (props) => {
  const { t } = useLanguage();
  const { user } = props;

  return (
    <div className="user-greeting-wrapper">
      <img
        className={`user-profile ${
          user.imageUrl === undefined || !user.imageUrl.length ? "empty" : ""
        }`}
        src={user.imageUrl ?? PersonOutline}
        alt={`Image ${user.name}`}
      />

      <h2 className="user-greeting">
        <b>{t.components.userGreeting[`welcome${user.gender ?? "M"}`]}</b>{" "}
        {user.name}
      </h2>
    </div>
  );
};

export default UserGreeting;
